import { render } from "./NuovoRapportinoAppuntamento.vue?vue&type=template&id=c4fa64fe&scoped=true"
import script from "./NuovoRapportinoAppuntamento.vue?vue&type=script&lang=js"
export * from "./NuovoRapportinoAppuntamento.vue?vue&type=script&lang=js"

import "./NuovoRapportinoAppuntamento.vue?vue&type=style&index=0&id=c4fa64fe&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_entasys/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4fa64fe"]])

export default __exports__